// extracted by mini-css-extract-plugin
export default {"wrapper":"MessageGroup_wrapper__09bEb","modalImg":"MessageGroup_modalImg__eBdmO"};